
  /**
   * docElement is a convenience wrapper to grab the root element of the document
   *
   * @access private
   * @returns {HTMLElement|SVGElement} The root element of the document
   */

  var docElement = document.documentElement;
  module.exports = docElement;




// WEBPACK FOOTER //
// ./project/client/src/core/vendor/browsernizr/lib/docElement.js